import FinancialSegmentsFields from "components/stocks/modern/fragments/FinancialSegmentsFields";
import gql from "graphql-tag";

export default gql`
  query FinancialBusinessSegments($tickerSymbol: TickerSymbol!) {
    financialBusinessSegments(tickerSymbol: $tickerSymbol) {
      ...FinancialSegmentsFields
    }
  }

  ${FinancialSegmentsFields}
`;
